import { useEffect, useRef } from 'react';

/**
 * Runs `effect` exactly once on mount, even under React 18 StrictMode's
 * double-invoked effects. Replaces the ad-hoc `useRef(false)` guard pattern.
 */
export function useRunOnce(effect: () => void) {
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
